import React, { useMemo, useState } from 'react';
import Wrapper from '../../components/Wrapper';
import { Paper, Typography, Box, IconButton, Link } from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { openAi, aiAnalytics, sip } from '../../translate';
import AssignedSearch from '../../components/new_component/AssignedSearch';

function localized(item, field, langIndex) {
  const suffix = langIndex === 3 ? 'hy' : langIndex === 2 ? 'ru' : 'en';
  return item[`${field}_${suffix}`] || item[`${field}_en`] || '';
}

export default function AiAnalyticsList() {
  const langIndex = +localStorage.getItem('atsLang') || 1;
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');

  const rows = useMemo(() => {
    const q = searchQuery.trim().toLowerCase();
    if (!q) return aiAnalytics;
    return aiAnalytics.filter((item) => {
      const title = localized(item, 'title', langIndex).toLowerCase();
      const description = localized(item, 'description', langIndex).toLowerCase();
      return title.includes(q) || description.includes(q) || String(item.id).toLowerCase().includes(q);
    });
  }, [searchQuery, langIndex]);

  const title = openAi.ai_analytics_title?.[langIndex] || 'AI Analytics';

  return (
    <Wrapper>
      <div className="tableParent">
        <Paper sx={{ p: 3 }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              mb: 2,
              borderBottom: '2px solid rgba(0, 0, 0, 0.08)',
              pb: 2.5,
            }}
          >
            <IconButton
              size="small"
              sx={{ color: '#7ebc0a', fontSize: 18 }}
              onClick={() => navigate('/short_function')}
              aria-label="Back"
            >
              <ArrowBackIosNewIcon sx={{ fontSize: 20, fontWeight: 700 }} />
            </IconButton>
            <AnalyticsIcon sx={{ color: '#7ebc0a', fontSize: 28 }} />
            <Typography variant="h5" sx={{ fontWeight: 700, m: 0 }}>
              {title}
            </Typography>
          </Box>

          <Box sx={{ mb: 2 }}>
            <AssignedSearch value={searchQuery} onChange={setSearchQuery} fullWidth />
          </Box>

          <div className="short-cards">
            {rows.map((item) => (
              <Paper key={item.id} className="short-card" elevation={0}>
                {item.img ? (
                  <Box
                    component="img"
                    src={item.img}
                    alt={localized(item, 'title', langIndex)}
                    sx={{
                      width: '100%',
                      height: 120,
                      objectFit: 'contain',
                      bgcolor: '#fff',
                      borderRadius: '4px',
                    }}
                  />
                ) : null}
                <div className="short-card__label">
                  {localized(item, 'title', langIndex)}
                </div>
                <div className="short-card__code">
                  {localized(item, 'description', langIndex)}
                </div>
                <div className="short-card__actions">
                  {item.link ? (
                    <Link
                      href={item.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={(e) => e.stopPropagation()}
                      sx={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: 0.5,
                        fontSize: 13,
                        fontWeight: 600,
                        color: '#7ebc0a',
                        textDecoration: 'none',
                        '&:hover': { textDecoration: 'underline' },
                      }}
                    >
                      {openAi.ai_analytics_info_link?.[langIndex] || 'View info'}
                      <OpenInNewIcon sx={{ fontSize: 15 }} />
                    </Link>
                  ) : (
                    <span />
                  )}
                  <span
                    onClick={() => navigate(`/short_function/ai_analytics/${encodeURIComponent(item.id)}`)}
                    className="edit"
                    title={sip.action?.[langIndex] || 'Open'}
                  >
                    <FontAwesomeIcon icon={faArrowRight} style={{ fontSize: 20 }} />
                  </span>
                </div>
              </Paper>
            ))}
          </div>
        </Paper>
      </div>
    </Wrapper>
  );
}
